import React from "react"

import { Row } from "../styles/Table.styled"

import PackageTableCell from "./PackageTableCell"

const PackageTableRow = ({ rowTitle, rowCells }) => {
  return (
    <Row>
      {rowTitle && <th scope="row">{rowTitle}</th>}
      {rowCells?.length > 0 &&
        rowCells?.map((rowCell) => (
          <PackageTableCell key={rowCell?.id} cell={rowCell} />
        ))}
    </Row>
  )
}

export default PackageTableRow
